<template>
  <div class="cam-page" v-loading="pageLoading" element-loading-text="加载中...">
    <el-tabs v-model="activeView" class="cam-tabs">
      <el-tab-pane label="维护与管理" name="maint">
        <div class="view open view--maint">
          <div class="maint-body">
            <aside class="side-card">
              <div class="side-hd">
                <span>分组</span>
                <el-button type="text" size="mini" @click="refreshAll">刷新</el-button>
              </div>
              <div class="side-bd">
                <el-input v-model.trim="searchGroup" clearable size="small" placeholder="搜索"
                  prefix-icon="el-icon-search" class="cam-search-input" />
                <div class="btn-row">
                  <el-button size="mini" @click="openMiniDirFromMaint">新建目录</el-button>
                  <el-button size="mini" type="primary" plain @click="openMiniPositionFromMaint">新建安装位置</el-button>
                </div>
                <el-tree ref="maintTree" :data="maintTreeData" node-key="treeKey"
                  :props="{ label: 'label', children: 'children' }" default-expand-all highlight-current
                  :expand-on-click-node="false" class="cam-tree"
                  @node-click="onMaintNodeClick">
                  <span slot-scope="{ data }" class="tree-node-row">
                    <span class="tree-node-twist" />
                    <span class="tree-node-icon">{{ isInstallLocationNode(data) ? '📍' : '📁' }}</span>
                    <span class="tree-node-label" :title="data.label">{{ data.label }}</span>
                    <button
                      v-if="canDeleteGroupNode(data)"
                      type="button"
                      class="tree-node-action tree-node-action--danger"
                      title="删除目录"
                      @click.stop="removeGroupNode(data)"
                    >
                      删除
                    </button>
                    <span v-if="isUngroupedNode(data)" class="ung-badge">未归类</span>
                  </span>
                </el-tree>
              </div>
            </aside>
            <section class="maint-main">
              <div class="toolbar">
                <div class="toolbar-left">
                  <el-button type="primary" size="small" icon="el-icon-plus" @click="openDrawerAdd">新增摄像头</el-button>
                  <el-button size="small" @click="$refs.fileCsv.click()">Excel导入</el-button>
              <input ref="fileCsv" type="file" accept=".xls,.xlsx,.csv" class="file-hide" @change="onCsvFile">
                  <el-button size="small" type="danger" plain :disabled="!tableSelection.length"
                    @click="batchDelete">删除</el-button>
                  <el-button size="small" @click="exportCsv">设备导出</el-button>
                </div>
                <div class="toolbar-right">
                  <el-input v-model.trim="searchTable" clearable size="small" placeholder="筛选名称 / 分组 / 地址"
                    prefix-icon="el-icon-search" class="toolbar-filter-input" />
                </div>
              </div>
              <div class="table-wrap">
                <el-table
                  :data="pagedTableRows"
                  border
                  stripe
                  height="100%"
                  style="flex: 1; min-height: 0;"
                  @selection-change="(v) => (tableSelection = v)"
                >
                  <el-table-column type="selection" width="44" />
                  <el-table-column prop="cameraName" label="设备名称" min-width="120" show-overflow-tooltip />
                  <el-table-column prop="streamUrl" label="码流地址" min-width="200" show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span class="mono">{{ shortUrl(scope.row.streamUrl) }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="安装位置" min-width="110" show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{ getCameraInstallLocation(scope.row) || '—' }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="所属分组" min-width="140" show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span v-if="!getCameraOwnerGroupName(scope.row)" class="ung-text">未分组</span>
                      <span v-else>{{ getCameraOwnerGroupName(scope.row) }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" width="120" fixed="right">
                    <template slot-scope="scope">
                      <button type="button" class="link-btn" @click="openDrawerEdit(scope.row)">编辑</button>
                      <button type="button" class="link-btn link-btn--danger" @click="removeOne(scope.row)">删除</button>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="table-pager">
                  <el-pagination
                    small
                    layout="prev, pager, next, total"
                    :total="filteredTableRows.length"
                    :page-size="tablePageSize"
                    :current-page.sync="tablePage"
                  />
                </div>
              </div>
            </section>
          </div>
        </div>
      </el-tab-pane>

      <el-tab-pane label="主预览" name="preview">
        <div class="view open view--preview">
          <div class="preview-body">
            <aside class="side-card side-card--border">
              <div class="side-hd">
                <span>自定义视图</span>
              </div>
              <div class="side-bd">
                <el-input v-model.trim="searchPreview" clearable size="small" placeholder="搜索"
                  prefix-icon="el-icon-search" class="cam-search-input" />
                <el-tree ref="previewTree" :data="previewTreeData" node-key="treeKey"
                  :props="{ label: 'label', children: 'children' }" default-expand-all :expand-on-click-node="false"
                  class="cam-tree" @node-click="onPreviewNodeClick">
                  <span slot-scope="{ data }" class="tree-node-row">
                    <span class="tree-node-twist" />
                    <span class="tree-node-icon">{{ data.nodeType === 'dir' ? '📁' : '📹' }}</span>
                    <span class="tree-node-label" :title="data.label">{{ data.label }}</span>
                  </span>
                </el-tree>
              </div>
            </aside>
            <div class="wall-area">
              <div class="wall-toolbar">
                <span class="wall-tit">
                  预览画面（海康 Web 插件）
                  <span v-if="info.name" class="wall-camera-name" :title="info.name">{{ info.name }}</span>
                </span>
                <div class="layout-btns">
                  <el-button size="mini" type="primary" plain class="wall-toolbar-btn" style="margin-left: 10px;"
                    @click="downloadPlugin">下载插件</el-button>
                </div>
              </div>
              <div class="wall-body">
                <template>
                  <HKVideo ref="hkVideo" v-if="info.ip" :info="info" />
                  <div v-else class="preview-empty">
                    <i class="el-icon-video-camera" />
                    <p>请选择摄像头</p>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>

    <!-- 添加/编辑摄像头 -->
    <el-drawer :title="drawerTitle" :visible.sync="drawerVisible" direction="rtl" size="460px" append-to-body
      :wrapper-closable="true" custom-class="cam-el-drawer" @close="closeDrawer">
      <el-form ref="camDrawerForm" :model="drawerForm" label-position="top" size="small" class="cam-drawer-form">
        <el-form-item label="设备名称" required>
          <el-input v-model.trim="drawerForm.cameraName" maxlength="200" placeholder="显示名称" clearable />
        </el-form-item>
        <el-form-item label="设备IP" required>
          <el-input v-model.trim="drawerForm.deviceIp" maxlength="100" placeholder="如 192.168.1.64" clearable />
        </el-form-item>
        <el-form-item label="账号" required>
          <el-input v-model.trim="drawerForm.deviceUsername" maxlength="100" placeholder="登录账号" clearable />
        </el-form-item>
        <el-form-item label="密码" :required="!drawerEditId">
          <el-input v-model="drawerForm.devicePassword" type="password" show-password maxlength="128"
            placeholder="设备登录密码" clearable autocomplete="new-password" />
        </el-form-item>
        <el-form-item label="通道" required>
          <el-input-number v-model="drawerForm.channel" :min="1" :max="512" :step="1" controls-position="right"
            class="cam-channel-input" />
        </el-form-item>
        <el-form-item label="安装位置" required>
          <el-select v-model="drawerForm.locationId" filterable clearable placeholder="请选择安装位置" class="cam-full-select">
            <el-option
              v-for="item in locationOptions"
              :key="item.id"
              :label="item.label"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <div class="cam-drawer-footer">
        <el-button size="small" @click="closeDrawer">取消</el-button>
        <el-button size="small" type="primary" @click="saveDrawer(true)">{{ drawerEditId ? '保存' : '新增' }}</el-button>
        <el-button v-if="!drawerEditId" size="small" type="primary" plain @click="saveDrawer(false)">保存并继续</el-button>
      </div>
    </el-drawer>

    <!-- 小弹窗：新建目录 / 新建安装位置 -->
    <el-dialog :title="miniTitle" :visible.sync="miniVisible" width="400px" append-to-body :close-on-click-modal="false"
      custom-class="cam-mini-dialog" @closed="onMiniDialogClosed">
      <el-form label-position="top" size="small" class="cam-mini-form">
        <el-form-item label="名称" required>
          <el-input v-model.trim="miniName" maxlength="100" placeholder="请输入名称" clearable />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeMini">取消</el-button>
        <el-button size="small" type="primary" @click="confirmMini">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import HikMultiPlayer from '@/basic-common/components/HikMultiPlayer.vue';
import { getTree, addGroup, removeGroup, getList, add, update, remove, importExcel } from './api';
import HKVideo from './HKVideo.vue';

const UNGROUPED_ID = '-1';

const toId = (id) => (id == null || id === '' ? null : String(id));
const isUngroupedId = (id) => String(id) === UNGROUPED_ID;

export default {
  name: 'device-camera/index',
  components: { HikMultiPlayer, HKVideo },
  data() {
    return {
      wallClock: '',
      clockTimer: null,
      activeView: 'maint',
      apiGroupTree: [],
      allCameras: [],
      searchPreview: '',
      searchGroup: '',
      searchTable: '',
      wallTick: 0,
      pageLoading: false,
      loadingCount: 0,
      filterManageGroupId: null,
      maintCurrentKey: null,
      tableSelection: [],
      tablePage: 1,
      tablePageSize: 20,
      drawerVisible: false,
      drawerTitle: '添加摄像头',
      drawerEditId: null,
      drawerForm: {
        cameraName: '',
        deviceIp: '',
        deviceUsername: '',
        devicePassword: '',
        channel: 1,
        locationId: '',
      },
      miniVisible: false,
      miniMode: null,
      miniParentId: null,
      miniTitle: '新建',
      miniName: '',
      info: { ip: null }
    };
  },
  computed: {
    baseGroupTree() {
      return this.buildGroupTree(this.apiGroupTree);
    },
    baseCameraTree() {
      return this.buildMixedTree(this.apiGroupTree, this.allCameras);
    },
    previewTreeData() {
      return this.filterTreeNodes(this.baseCameraTree, this.searchPreview);
    },
    maintTreeData() {
      return this.filterTreeNodes(this.baseGroupTree, this.searchGroup);
    },
    locationOptions() {
      const options = [];
      const walk = (nodes, parents = []) => {
        (nodes || []).forEach((node) => {
          if (this.isInstallLocationNode(node)) {
            options.push({
              id: node.id,
              name: node.label,
              label: [...parents, node.label].join(' / '),
            });
          }
          walk(node.children || [], [...parents, node.label]);
        });
      };
      walk((this.baseGroupTree || []).filter((node) => !isUngroupedId(node.id)));
      return options;
    },
    filteredTableRows() {
      const g = this.filterManageGroupId;
      const q = (this.searchTable || '').trim().toLowerCase();
      return this.allCameras.filter((row) => {
        if (g != null) {
          if (isUngroupedId(g)) {
            if (toId(row.groupId) != null) return false;
          } else if (!this.getGroupWithDescendantIds(g).includes(toId(row.groupId))) {
            return false;
          }
        }
        if (!q) return true;
        const blob = `${row.cameraName || ''} ${row.deviceIp || ''} ${row.deviceUsername || ''} ${row.streamUrl || ''} ${this.getCameraInstallLocation(row) || ''} ${this.getCameraOwnerGroupName(row) || ''}`.toLowerCase();
        return blob.includes(q);
      });
    },
    pagedTableRows() {
      const start = (this.tablePage - 1) * this.tablePageSize;
      return this.filteredTableRows.slice(start, start + this.tablePageSize);
    },
  },
  watch: {
    filteredTableRows() {
      const maxP = Math.max(1, Math.ceil(this.filteredTableRows.length / this.tablePageSize) || 1);
      if (this.tablePage > maxP) this.tablePage = maxP;
    },
    activeView(v) {
      if (v === 'preview') {
        this.$nextTick(() => {
          this.wallTick += 1;
        });
      } else {
        this.stopPreviewPlugin();
      }
    },
  },

  deactivated() {
    console.log("deactivated")
    this.stopPreviewPlugin();
  },
  mounted() {
    this.tickClock();
    this.clockTimer = setInterval(this.tickClock, 1000);
    this.refreshAll();
  },
  beforeDestroy() {
    if (this.clockTimer) clearInterval(this.clockTimer);
    this.stopPreviewPlugin();
  },
  beforeRouteLeave(to, from, next) {
    this.stopPreviewPlugin();
    next();
  },
  methods: {
    stopPreviewPlugin() {
      if (this.info) this.info.ip = null;
      if (this.$refs.hkVideo) {
        if (this.$refs.hkVideo.teardownPlugin) {
          this.$refs.hkVideo.teardownPlugin();
        } else {
          this.$refs.hkVideo.stopRealPlay && this.$refs.hkVideo.stopRealPlay();
          this.$refs.hkVideo.handleLogout && this.$refs.hkVideo.handleLogout();
        }
      }
    },
    async withPageLoading(task) {
      this.loadingCount += 1;
      this.pageLoading = true;
      try {
        return await task();
      } finally {
        this.loadingCount -= 1;
        if (this.loadingCount <= 0) {
          this.loadingCount = 0;
          this.pageLoading = false;
        }
      }
    },
    tickClock() {
      const d = new Date();
      const w = '日一二三四五六'.charAt(d.getDay());
      const p = (n) => String(n).padStart(2, '0');
      this.wallClock = `${d.getFullYear()}年${p(d.getMonth() + 1)}月${p(d.getDate())}日 星期${w} ${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`;
    },

    buildStaticAssetUrl(path) {
      const getLoadedAssetBase = () => {
        const suffix = 'util/HKVideoPlugin3.9.9/webVideoCtrl.js';
        const scripts = Array.from(document.scripts || []);
        for (let i = scripts.length - 1; i >= 0; i -= 1) {
          const src = scripts[i].src || '';
          const index = src.indexOf(suffix);
          if (index > -1) return src.slice(0, index);
        }
        return '';
      };
      const base =
        (window.__POWERED_BY_QIANKUN__ && window.__INJECTED_PUBLIC_PATH_BY_QIANKUN__) ||
        getLoadedAssetBase() ||
        process.env.BASE_URL ||
        '/';
      const normalizedBase = base.endsWith('/') ? base : `${base}/`;
      const cleanPath = String(path || '').replace(/^\/+/, '');
      if (/^https?:\/\//i.test(normalizedBase)) {
        return new URL(cleanPath, normalizedBase).toString();
      }
      return `${normalizedBase}${cleanPath}`;
    },

    downloadPlugin() {
      const fileUrl = this.buildStaticAssetUrl('HCWebSDKPlugin.exe');
      const fileName = 'HCWebSDKPlugin.exe';

      const link = document.createElement('a');
      link.href = fileUrl;
      link.download = fileName;
      link.target = '_blank';

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      this.$message.success('插件下载已开始，请等待下载完成');
    },

    onPreviewNodeClick(data) {
      console.log('预览树选中节点:', data);

      if (data.nodeType === 'cam' && data.camera) {
        this.handleCameraSelect(data.camera);
      } else if (data.nodeType === 'dir') {
        console.log('选中了目录:', data.label);
      }
    },

    shortUrl(u) {
      if (!u) return '—';
      return u.length > 72 ? `${u.slice(0, 72)}…` : u;
    },
    buildGroupTree(groups) {
      const walkGroup = (g, parentId = null) => {
        const gid = toId(g.id);
        return {
          treeKey: `g-${g.id}`,
          label: g.label,
          nodeType: 'dir',
          id: gid,
          parentId,
          children: (g.children || []).map((child) => walkGroup(child, gid)),
        };
      };
      const ung = {
        treeKey: 'g-ungrouped',
        label: '未分组',
        nodeType: 'dir',
        id: UNGROUPED_ID,
        parentId: null,
        children: [],
      };
      return [ung, ...(groups || []).map((g) => walkGroup(g, null))];
    },
    buildMixedTree(groups, cameras) {
      const byGid = new Map();
      (cameras || []).forEach((c) => {
        const gid = toId(c.groupId) || UNGROUPED_ID;
        if (!byGid.has(gid)) byGid.set(gid, []);
        byGid.get(gid).push(c);
      });
      const sortCams = (arr) =>
        [...arr].sort((a, b) => (a.sortNo || 0) - (b.sortNo || 0) || String(a.id).localeCompare(String(b.id)));
      const camNodes = (gid) =>
        sortCams(byGid.get(gid) || []).map((c) => ({
          treeKey: `c-${c.id}`,
          label: c.cameraName || '未命名',
          nodeType: 'cam',
          id: c.id,
          camera: c,
        }));
      const walkGroup = (g, parentId = null) => {
        const gid = toId(g.id);
        const sub = (g.children || []).map((child) => walkGroup(child, gid));
        return {
          treeKey: `g-${g.id}`,
          label: g.label,
          nodeType: 'dir',
          id: gid,
          parentId,
          children: [...sub, ...camNodes(gid)],
        };
      };
      const ung = {
        treeKey: 'g-ungrouped',
        label: '未分组',
        nodeType: 'dir',
        id: UNGROUPED_ID,
        parentId: null,
        children: camNodes(UNGROUPED_ID),
      };
      return [ung, ...(groups || []).map((g) => walkGroup(g, null))];
    },
    isInstallLocationNode(data) {
      return data && data.nodeType === 'dir' && !isUngroupedId(data.id) && data.parentId != null;
    },
    isUngroupedNode(data) {
      return data && data.nodeType === 'dir' && isUngroupedId(data.id);
    },
    getDirNodeById(id) {
      if (id == null || id === '') return null;
      const target = toId(id);
      const find = (nodes) => {
        for (const n of nodes || []) {
          if (toId(n.id) === target) return n;
          const sub = find(n.children);
          if (sub) return sub;
        }
        return null;
      };
      return find(this.baseGroupTree);
    },
    getGroupWithDescendantIds(id) {
      const root = this.getDirNodeById(id);
      if (!root) return [toId(id)];
      const ids = [];
      const walk = (node) => {
        if (node && !isUngroupedId(node.id)) ids.push(toId(node.id));
        (node.children || []).forEach(walk);
      };
      walk(root);
      return ids;
    },
    getCameraInstallLocation(row) {
      const node = row && this.getDirNodeById(row.groupId);
      if (this.isInstallLocationNode(node)) return node.label;
      return (row && row.installLocation) || '';
    },
    getCameraOwnerGroupName(row) {
      const node = row && this.getDirNodeById(row.groupId);
      if (!node) return (row && row.groupName) || '';
      if (this.isInstallLocationNode(node)) {
        const parent = this.getDirNodeById(node.parentId);
        return parent ? parent.label : '';
      }
      return node.label || (row && row.groupName) || '';
    },
    matchesForSearch(n, ql) {
      if (!ql) return true;
      if ((n.label || '').toLowerCase().includes(ql)) return true;
      if (n.nodeType === 'cam') {
        const c = n.camera || {};
        if ((c.deviceIp || '').toLowerCase().includes(ql)) return true;
        if ((c.deviceUsername || '').toLowerCase().includes(ql)) return true;
        if ((c.installLocation || '').toLowerCase().includes(ql)) return true;
        if ((c.streamUrl || '').toLowerCase().includes(ql)) return true;
      }
      return false;
    },
    filterTreeNodes(nodes, q) {
      const ql = (q || '').trim().toLowerCase();
      if (!ql) return nodes || [];
      const walk = (arr) => {
        const res = [];
        (arr || []).forEach((n) => {
          const kidsIn = n.children || [];
          const kids = walk(kidsIn);
          const sm = this.matchesForSearch(n, ql);
          if (sm) {
            try {
              res.push(JSON.parse(JSON.stringify(n)));
            } catch (e) {
              res.push({ ...n, children: kidsIn });
            }
          } else if (kids.length) {
            res.push({ ...n, children: kids });
          }
        });
        return res;
      };
      return walk(nodes || []);
    },
    async loadGroupTree() {
      const res = await getTree();
      console.log("RES", res)
      const raw = (res.data && res.data.data) || res.data || [];
      this.apiGroupTree = Array.isArray(raw) ? raw : [];
    },
    async loadAllCameras() {
      const out = [];
      let page = 1;
      const size = 500;
      for (; ;) {
        const res = await getList({ page, size });
        const body = res.data && res.data.data;
        const rec = (body && body.records) || [];
        out.push(...rec);
        if (rec.length < size) break;
        page += 1;
        if (page > 200) break;
      }
      this.allCameras = out;
    },
    async refreshAll() {
      return this.withPageLoading(async () => {
        await this.loadGroupTree();
        await this.loadAllCameras();
        this.wallTick += 1;
      }).catch((e) => {
        this.$message.error((e && e.message) || '加载失败');
      });
    },
    allowDragCam(node) {
      return node.data && node.data.nodeType === 'cam';
    },
    allowDropOnDir(draggingNode, dropNode, type) {
      if (!dropNode || !dropNode.data) return false;
      if (dropNode.data.nodeType !== 'dir') return false;
      return type === 'inner';
    },
    async onCamDrop(draggingNode, dropNode, dropType) {
      if (dropType !== 'inner' || !draggingNode.data || draggingNode.data.nodeType !== 'cam') return;
      const cam = draggingNode.data.camera;
      const targetId = dropNode.data.id;
      const newGid = isUngroupedId(targetId) ? null : toId(targetId);
      const oldGid = toId(cam.groupId);
      if (oldGid === newGid) return;
      const payload = { ...cam, groupId: newGid };
      await this.withPageLoading(async () => {
        await update(payload);
        this.$message.success('已调整目录');
        await this.refreshAll();
      }).catch(() => {});
    },
    onMaintNodeClick(data) {
      console.log("data", data)
      this.maintCurrentKey = data.treeKey;
      this.$nextTick(() => {
        if (this.$refs.maintTree) this.$refs.maintTree.setCurrentKey(data.treeKey);
      });
      this.filterManageGroupId = isUngroupedId(data.id) ? UNGROUPED_ID : toId(data.id);
      this.tablePage = 1;
    },

    handleCameraSelect(camera) {
      console.log('选中的摄像头数据:', camera);
      const ip = (camera.deviceIp || '').trim();
      if (!ip) {
        this.$message.warning('该摄像头未配置设备 IP，无法预览');
        return;
      }

      this.info = {
        name: camera.cameraName || '未命名',
        ip,
        port: camera.httpPort || 80,
        username: camera.deviceUsername || '',
        password: camera.devicePassword || '',
        channel: camera.channel || 1,
        streamType: camera.streamType || 1,
      };

      console.log('海康插件连接信息:', this.info);

      if (this.$refs.hkVideo && this.activeView === 'preview') {
        this.$nextTick(() => {
          this.$refs.hkVideo.switchCamera && this.$refs.hkVideo.switchCamera(this.info);
        });
      }
    },

    clearGroupFilter() {
      this.filterManageGroupId = null;
      this.maintCurrentKey = null;
      if (this.$refs.maintTree) this.$refs.maintTree.setCurrentKey(null);
      this.tablePage = 1;
    },
    openMiniDir(parentId) {
      this.miniMode = 'dir';
      this.miniParentId = parentId;
      this.miniTitle = '新建目录';
      this.miniName = '';
      this.miniVisible = true;
    },
    openMiniDirFromMaint() {
      const parentId = this.resolveNewGroupParentId();
      this.openMiniDir(parentId);
    },
    /**
     * 新建目录的 parentId：须在「未过滤」树上解析当前选中节点，否则搜索后 maintTreeData 不含该节点会误判为根目录。
     */
    resolveNewGroupParentId() {
      const dir = this.getMaintSelectedDir();
      if (dir) {
        if (isUngroupedId(dir.id)) return null;
        return dir.id;
      }
      return null;
    },
    openMiniPositionFromMaint() {
      const hit = this.getMaintSelectedDir();
      if (!hit || isUngroupedId(hit.id)) {
        this.$message.warning('请先选择一个实际目录，再新建安装位置。');
        return;
      }
      this.miniMode = 'location';
      this.miniParentId = hit.id;
      this.miniTitle = '新建安装位置';
      this.miniName = '';
      this.miniVisible = true;
    },
    getMaintSelectedDir() {
      if (!this.maintCurrentKey) return null;
      const find = (nodes) => {
        for (const n of nodes || []) {
          if (n.treeKey === this.maintCurrentKey && n.nodeType === 'dir') return n;
          const sub = find(n.children);
          if (sub) return sub;
        }
        return null;
      };
      return find(this.baseGroupTree);
    },
    getMaintSelectedCamNode() {
      if (!this.maintCurrentKey) return null;
      const find = (nodes) => {
        for (const n of nodes || []) {
          if (n.treeKey === this.maintCurrentKey && n.nodeType === 'cam') return n;
          const sub = find(n.children);
          if (sub) return sub;
        }
        return null;
      };
      return find(this.baseCameraTree);
    },
    findBaseTreeNodeByKey(treeKey) {
      if (!treeKey) return null;
      const find = (nodes) => {
        for (const n of nodes || []) {
          if (n.treeKey === treeKey) return n;
          const sub = find(n.children);
          if (sub) return sub;
        }
        return null;
      };
      return find(this.baseGroupTree);
    },
    canDeleteGroupNode(data) {
      return data && data.nodeType === 'dir' && !isUngroupedId(data.id);
    },
    async removeGroupNode(data) {
      if (!this.canDeleteGroupNode(data)) return;
      const node = this.findBaseTreeNodeByKey(data.treeKey) || data;
      const children = node.children || [];
      if (children.length) {
        this.$message.warning('请先清空或迁移该目录下的子节点');
        return;
      }
      const hasCamera = this.allCameras.some((row) => toId(row.groupId) === toId(node.id));
      if (hasCamera) {
        this.$message.warning('请先迁移或删除该节点下的摄像头');
        return;
      }
      try {
        await this.$confirm('确定删除该节点？', '提示', { type: 'warning' });
        await this.withPageLoading(async () => {
          await removeGroup(node.id);
          if (this.maintCurrentKey === node.treeKey) {
            this.maintCurrentKey = null;
            this.filterManageGroupId = null;
            if (this.$refs.maintTree) this.$refs.maintTree.setCurrentKey(null);
          }
          this.$message.success('已删除');
          await this.refreshAll();
        });
      } catch (e) {
        if (e && e !== 'cancel' && e !== 'close') {
          this.$message.error((e.response && e.response.data && e.response.data.msg) || e.message || '删除失败');
        }
      }
    },
    async confirmMini() {
      const name = (this.miniName || '').trim();
      if (!name) {
        this.$message.warning('请填写名称');
        return;
      }
      if (this.miniMode === 'dir') {
        let parentId = this.miniParentId;
        if (isUngroupedId(parentId)) parentId = null;
        try {
          await this.withPageLoading(async () => {
            await addGroup({
              parentId: parentId == null ? null : toId(parentId),
              groupName: name,
              sortNo: 0,
            });
            this.$message.success('保存成功');
            this.closeMini();
            await this.refreshAll();
          });
        } catch (e) {
          const msg =
            (e && ((e.response && e.response.data && e.response.data.msg) || e.message)) || '保存失败';
          this.$message.error(msg);
        }
        return;
      }
      if (this.miniMode !== 'location') {
        return;
      }
      try {
        await this.withPageLoading(async () => {
          await addGroup({
            parentId: toId(this.miniParentId),
            groupName: name,
            sortNo: 0,
          });
          this.$message.success('保存成功');
          this.closeMini();
          await this.refreshAll();
        });
      } catch (e) {
        const msg =
          (e && ((e.response && e.response.data && e.response.data.msg) || e.message)) || '保存失败';
        this.$message.error(msg);
      }
    },
    closeMini() {
      this.miniVisible = false;
      this.miniMode = null;
    },
    /** 对话框通过右上角关闭等结束时，同步清空 miniMode（取消按钮仍走 closeMini） */
    onMiniDialogClosed() {
      this.miniMode = null;
    },
    openDrawerAdd() {
      this.drawerEditId = null;
      this.drawerTitle = '新增摄像头';
      this.drawerForm = {
        cameraName: '',
        deviceIp: '',
        deviceUsername: '',
        devicePassword: '',
        channel: 1,
        locationId: this.pickDefaultLocationId(),
      };
      this.drawerVisible = true;
    },
    pickDefaultLocationId() {
      const hit = this.getMaintSelectedDir();
      if (this.isInstallLocationNode(hit)) return hit.id;
      const filterNode = this.getDirNodeById(this.filterManageGroupId);
      if (this.isInstallLocationNode(filterNode)) return filterNode.id;
      return '';
    },
    openDrawerEdit(row) {
      this.drawerEditId = row.id;
      this.drawerTitle = '编辑摄像头';
      const locationNode = this.getDirNodeById(row.groupId);
      this.drawerForm = {
        cameraName: row.cameraName || row.deviceIp || '',
        deviceIp: row.deviceIp || '',
        deviceUsername: row.deviceUsername || '',
        devicePassword: '',
        channel: row.channel != null && row.channel !== '' ? Number(row.channel) : 1,
        locationId: this.isInstallLocationNode(locationNode) ? locationNode.id : '',
      };
      this.drawerVisible = true;
    },
    closeDrawer() {
      this.drawerVisible = false;
      this.drawerEditId = null;
    },
    async saveDrawer(closeAfter) {
      const name = (this.drawerForm.cameraName || '').trim();
      const ip = (this.drawerForm.deviceIp || '').trim();
      const username = (this.drawerForm.deviceUsername || '').trim();
      const pwdInput = (this.drawerForm.devicePassword || '').trim();
      const ch = Number(this.drawerForm.channel);
      const channel = Number.isFinite(ch) && ch >= 1 ? Math.min(512, Math.floor(ch)) : 1;
      if (!name) {
        this.$message.warning('请填写设备名称。');
        return;
      }
      if (!ip) {
        this.$message.warning('请填写设备 IP。');
        return;
      }
      if (!username) {
        this.$message.warning('请填写账号。');
        return;
      }
      if (!this.drawerEditId && !pwdInput) {
        this.$message.warning('请填写密码。');
        return;
      }
      const selectedLocationId = this.drawerForm.locationId;
      const selectedLocation = this.getDirNodeById(selectedLocationId);
      if (!this.drawerEditId && !this.isInstallLocationNode(selectedLocation)) {
        this.$message.warning('新增摄像头必须选择一个安装位置。');
        return;
      }
      const row = this.drawerEditId ? this.allCameras.find((c) => String(c.id) === String(this.drawerEditId)) : null;
      if (this.drawerEditId && !row) {
        this.$message.error('未找到该设备数据，请刷新后重试。');
        return;
      }
      let devicePassword = pwdInput;
      if (this.drawerEditId && !pwdInput && row) {
        devicePassword = row.devicePassword || '';
      }
      const groupId = this.isInstallLocationNode(selectedLocation)
        ? selectedLocation.id
        : (row ? toId(row.groupId) : null);
      const installLocation = this.isInstallLocationNode(selectedLocation)
        ? selectedLocation.label
        : ((row && row.installLocation) || '');
      const base = {
        cameraName: name,
        deviceIp: ip,
        deviceUsername: username,
        devicePassword,
        channel,
        streamUrl: (row && row.streamUrl) || '',
        installLocation,
        httpPort: (row && row.httpPort != null) ? row.httpPort : 80,
        streamType: (row && row.streamType != null) ? row.streamType : 1,
        groupId,
        sortNo: (row && row.sortNo != null) ? row.sortNo : 0,
      };
      await this.withPageLoading(async () => {
        if (this.drawerEditId && row) {
          await update({ ...row, ...base, id: this.drawerEditId });
        } else {
          await add(base);
        }
        this.$message.success('操作成功');
        if (closeAfter) this.closeDrawer();
        else if (!this.drawerEditId) {
          this.drawerForm.cameraName = '';
          this.drawerForm.deviceIp = '';
          this.drawerForm.deviceUsername = '';
          this.drawerForm.devicePassword = '';
          this.drawerForm.channel = 1;
          this.drawerForm.locationId = this.pickDefaultLocationId();
        }
        await this.refreshAll();
      }).catch(() => {});
    },
    async removeOne(row) {
      try {
        await this.$confirm('确定删除该设备？', '提示', { type: 'warning' });
        await this.withPageLoading(async () => {
          await remove(row.id);
          this.$message.success('已删除');
          await this.refreshAll();
        });
      } catch (e) {
        if (e && e !== 'cancel' && e !== 'close') {
          this.$message.error((e.response && e.response.data && e.response.data.msg) || e.message || '删除失败');
        }
      }
    },
    async batchDelete() {
      const ids = this.tableSelection.map((r) => r.id);
      if (!ids.length) return;
      try {
        await this.$confirm(`确定删除选中的 ${ids.length} 项？`, '提示', { type: 'warning' });
        await this.withPageLoading(async () => {
          for (const id of ids) {
            await remove(id);
          }
          this.$message.success('已删除');
          await this.refreshAll();
        });
      } catch (e) {
        if (e && e !== 'cancel' && e !== 'close') {
          this.$message.error((e.response && e.response.data && e.response.data.msg) || e.message || '删除失败');
        }
      }
    },
    onCsvFile(ev) {
      const f = ev.target.files && ev.target.files[0];
      ev.target.value = '';
      if (!f) return;
      const fd = new FormData();
      fd.append('file', f);
      this.withPageLoading(async () => {
        await importExcel(fd);
          this.$message.success('导入成功');
          await this.refreshAll();
      })
        .catch((err) => {
          const msg =
            (err && ((err.response && err.response.data && err.response.data.msg) || err.message)) ||
            '导入失败';
          this.$message.error(msg);
        });
    },
    async parseCsvImport(text) {
      const lines = text.split(/\r?\n/).map((l) => l.trim()).filter((l) => l.length);
      if (!lines.length) return 0;
      let start = 0;
      const h = lines[0];
      if (/设备名称|cameraName|码流/i.test(h) && /码流|stream/i.test(h)) start = 1;
      let n = 0;
      for (let i = start; i < lines.length; i++) {
        const cols = this.splitCsvLine(lines[i]);
        const cameraName = (cols[0] || '').trim();
        const installLocation = (cols[1] || '').trim();
        const streamUrl = (cols[2] || '').trim();
        const groupPath = (cols[3] || '').trim();
        if (!cameraName || !streamUrl) continue;
        let groupId = null;
        if (groupPath) {
          const hit = this.findDirByPath(groupPath);
          groupId = hit != null ? hit : null;
        }
        await add({ cameraName, installLocation, streamUrl, groupId, sortNo: 0 });
        n += 1;
      }
      return n;
    },
    splitCsvLine(line) {
      const out = [];
      let cur = '';
      let q = false;
      for (let i = 0; i < line.length; i++) {
        const ch = line[i];
        if (ch === '"') {
          q = !q;
        } else if (ch === ',' && !q) {
          out.push(cur);
          cur = '';
        } else cur += ch;
      }
      out.push(cur);
      return out.map((c) => c.trim().replace(/^"|"$/g, ''));
    },
    findDirByPath(pathStr) {
      const parts = pathStr.split(/[\u2192\u2190>→/]/).map((s) => s.trim()).filter(Boolean);
      if (!parts.length) return null;
      const matchName = (nodes, name) => (nodes || []).find((n) => n.nodeType === 'dir' && n.label === name);
      let list = this.baseGroupTree;
      let found = null;
      for (const part of parts) {
        found = matchName(list, part);
        if (!found) return null;
        list = found.children || [];
      }
      return found && found.nodeType === 'dir' ? found.id : null;
    },
    exportCsv() {
      const header = '设备名称,安装位置,码流地址,所属分组';
      const lines = [header];
      this.allCameras.forEach((row) => {
        const g = this.getCameraOwnerGroupName(row) || '未分组';
        const esc = (s) => `"${String(s || '').replace(/"/g, '""')}"`;
        lines.push([esc(row.cameraName), esc(this.getCameraInstallLocation(row)), esc(row.streamUrl), esc(g)].join(','));
      });
      const blob = new Blob(['\ufeff' + lines.join('\r\n')], { type: 'text/csv;charset=utf-8' });
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = `摄像头导出_${Date.now()}.csv`;
      a.click();
      URL.revokeObjectURL(a.href);
    },
  },
};
</script>

<style scoped lang="scss">
:root {
  --cam-bg: #f5f7fb;
  --cam-card: #ffffff;
  --cam-text: #1f2329;
  --cam-sub: #667085;
  --cam-primary: #1677ff;
  --cam-border: #e4e7ec;
  --cam-danger: #f04438;
  --cam-shadow: 0 4px 14px rgba(15, 23, 42, 0.06);
}

.cam-page {
  font-size: 14px;
  color: var(--cam-text);
  background: var(--cam-bg);
  height: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.cam-tabs {
  height: 100%;
}

:deep(.cam-tabs > .el-tabs__content) {
  height: calc(100% - 55px);
}

:deep(.cam-tabs .el-tab-pane) {
  height: 100%;
}

.view {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.view.open {
  display: flex;
}

.preview-body {
  flex: 1;
  display: grid;
  grid-template-columns: 280px 1fr;
  min-height: 0;
  height: 100%;
  gap: 14px;
}

@media (max-width: 960px) {
  .preview-body {
    grid-template-columns: 1fr;
  }
}

.side-card {
  background: var(--cam-card);
  display: flex;
  flex-direction: column;
  min-height: 0;
  border: 1px solid #e4e7ec;
  border-radius: 10px;
  box-shadow: var(--cam-shadow);
  overflow: hidden;
  background: #ffffff;
}

.side-card--border {
  border-right: 1px solid #e4e7ec;
}

.side-hd {
  padding: 12px 14px;
  font-weight: 700;
  font-size: 13px;
  border-bottom: 1px solid #e4e7ec;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.side-bd {
  padding: 10px 12px;
  overflow: auto;
  flex: 1;
}

.cam-search-input {
  margin-bottom: 10px;
}

.toolbar-filter-input {
  width: 220px;
}

.wall-toolbar-btn {
  background: #fff;
  border-color: #e4e7ec;
  color: var(--cam-text);
}

.wall-toolbar-btn:hover,
.wall-toolbar-btn:focus {
  background: #f9fafb;
  border-color: #cfd4dc;
  color: var(--cam-text);
}

.toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 12px 16px;
  background: var(--cam-card);
  border-bottom: 1px solid #e4e7ec;
}

.toolbar-left,
.toolbar-right {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.maint-body {
  flex: 1;
  display: grid;
  grid-template-columns: 280px 1fr;
  min-height: 0;
  gap: 14px;
  height: 100%;
}

.maint-main {
  min-height: 0;
  height: 100%;
  background: #ffffff;
  border: 1px solid #e4e7ec;
  border-radius: 10px;
  box-shadow: var(--cam-shadow);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

@media (max-width: 960px) {
  .maint-body {
    grid-template-columns: 1fr;
  }
}

.table-wrap {
  overflow: hidden;
  flex: 1;
  background: var(--cam-card);
  display: flex;
  flex-direction: column;
  min-height: 0;
  padding: 12px;
  box-sizing: border-box;
}

.table-wrap :deep(.el-table__header-wrapper th) {
  background: #f8fafc;
  color: #1f2329;
  font-weight: 700;
}
.table-wrap :deep(.el-table__header-wrapper .cell) {
  line-height: 18px;
}
.table-wrap :deep(.el-table__body tr:hover td) {
  background: #f5f7fb;
}
.table-wrap :deep(.el-table__body td) {
  padding: 10px 0;
}
.table-wrap :deep(.el-table__empty-block) {
  padding: 24px 0;
}
.table-wrap :deep(.link-btn + .link-btn) {
  margin-left: 10px;
}

.table-pager {
  padding: 8px 12px;
  border-top: 1px solid #e4e7ec;
  text-align: right;
}

.mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: 11px;
}

.link-btn {
  border: none;
  background: none;
  color: var(--cam-primary);
  cursor: pointer;
  font-size: 12px;
  padding: 0 4px;
}

.link-btn--danger {
  color: var(--cam-danger);
}

.table-wrap .link-btn--danger {
  color: #f04438 !important;
  font-weight: 700;
}

.table-wrap .link-btn--danger:hover {
  color: #d9362e !important;
}

.hint {
  font-size: 11px;
  color: var(--cam-sub);
  line-height: 1.45;
}

.hint--mb {
  margin: 0 0 8px;
}

.hint--mb6 {
  margin-bottom: 6px;
}

.btn-row {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 8px;
}

.ung-badge {
  font-size: 10px;
  font-weight: 700;
  color: #f79009;
  background: #fffaeb;
  border: 1px solid #fedf89;
  border-radius: 4px;
  padding: 1px 6px;
  flex-shrink: 0;
}

.ung-text {
  color: #b54708;
  font-weight: 600;
}

.wall-area {
  background: var(--cam-card);
  display: flex;
  flex-direction: column;
  min-height: 0;
  border: 1px solid #e4e7ec;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: var(--cam-shadow);
  padding: 0;
}

.maint-panel-empty {
  flex: 1;
  min-height: 0;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 10px;
  border: 1px dashed #d0d5dd;
  border-radius: 8px;
}

.maint-panel-empty__inner {
  text-align: center;
  color: var(--cam-sub);
}

.maint-panel-empty__inner i {
  font-size: 34px;
  color: #98a2b3;
  display: block;
  margin-bottom: 10px;
}

.maint-panel-empty__inner p {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #475467;
}

.maint-panel-empty__inner span {
  display: block;
  margin-top: 8px;
  font-size: 12px;
}

@media (max-width: 960px) {
  .wall-area {
    min-height: 360px;
  }
}

.wall-body {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  position: relative;
  padding: 10px;
  border-top: 1px solid #e4e7ec;
  box-sizing: border-box;
  background: #4c4b4b;
}

.preview-empty {
  flex: 1;
  min-height: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #cbd5e1;
  gap: 10px;
}

.preview-empty i {
  font-size: 42px;
  color: #94a3b8;
}

.preview-empty p {
  margin: 0;
  font-size: 14px;
}

.hik-wall-fill {
  flex: 1;
  min-height: 400px;
}

.wall-fallback {
  flex: 1;
  padding: 24px;
  font-size: 13px;
  line-height: 1.6;
  color: #e4e7ec;
}

.wall-fallback code {
  font-size: 11px;
  color: #93c5fd;
}

.wall-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
  padding: 10px 14px;
  background: #fff;
  border-bottom: 1px solid #e4e7ec;
  border-radius: 8px 8px 0 0;
}

.wall-tit {
  color: var(--cam-text);
  font-size: 13px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  max-width: 100%;
}

.wall-camera-name {
  color: #2563eb;
  font-weight: 600;
  min-width: 0;
  max-width: 360px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.layout-btns {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  align-items: center;
}

.wall-grid {
  flex: 1;
  padding: 10px;
  display: grid;
  gap: 6px;
  overflow: auto;
  align-content: start;
}

.wall-grid.cols-1 {
  grid-template-columns: 1fr;
}

.wall-grid.cols-2 {
  grid-template-columns: repeat(2, 1fr);
}

.wall-grid.cols-3 {
  grid-template-columns: repeat(3, 1fr);
}

.cell {
  aspect-ratio: 16 / 9;
  background: linear-gradient(160deg, #0f1419 0%, #1c222b 45%, #12161c 100%);
  border-radius: 4px;
  border: 1px solid #2d333d;
  position: relative;
  overflow: hidden;
  min-height: 80px;
}

.cell .ts {
  position: absolute;
  top: 8px;
  left: 8px;
  font-size: 11px;
  color: rgba(255, 255, 255, 0.92);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.8);
  z-index: 4;
  font-family: ui-monospace, monospace;
}

.cell .nm {
  position: absolute;
  right: 8px;
  bottom: 8px;
  font-size: 12px;
  font-weight: 600;
  color: #fff;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.9);
  z-index: 4;
  max-width: 85%;
  text-align: right;
  line-height: 1.35;
}

.nm-sub {
  font-weight: 400;
  font-size: 11px;
  opacity: 0.9;
}

.cell .ph {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #5c6370;
  font-size: 11px;
  z-index: 1;
}

.cell .live {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #22c55e;
  box-shadow: 0 0 8px #22c55e;
  z-index: 4;
}

.cell-player {
  position: absolute;
  inset: 0;
  z-index: 2;
}

:deep(.cam-el-drawer .el-drawer__body) {
  padding: 8px 20px 16px;
  display: flex;
  flex-direction: column;
  height: calc(100% - 56px);
  box-sizing: border-box;
}

.cam-drawer-form {
  flex: 1;
  min-height: 0;
  overflow: auto;
}

.cam-drawer-footer {
  flex-shrink: 0;
  padding-top: 12px;
  margin-top: 8px;
  border-top: 1px solid #e4e7ec;
  text-align: right;
}

.cam-drawer-footer .el-button+.el-button {
  margin-left: 8px;
}

.cam-channel-input {
  width: 100%;
}

.cam-full-select {
  width: 100%;
}

.req {
  color: var(--cam-danger);
}

.tree-node-row {
  display: flex;
  align-items: center;
  gap: 6px;
  flex: 1;
  width: 100%;
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
  padding-right: 4px;
  min-height: 32px;
  box-sizing: border-box;
}

.tree-node-twist {
  width: 18px;
  flex-shrink: 0;
}

.tree-node-icon {
  font-size: 13px;
  flex-shrink: 0;
  opacity: 0.85;
}

.tree-node-label {
  flex: 1;
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 13px;
  display: block;
}

.tree-node-action {
  display: none;
  flex-shrink: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 12px;
  line-height: 1;
  padding: 2px 4px;
}

.tree-node-action--danger {
  color: var(--cam-danger);
}

.file-hide {
  display: none;
}

:deep(.cam-tree .el-tree-node__content) {
  height: auto;
  min-height: 32px;
  padding: 4px 0;
  border-radius: 8px;
  max-width: 100%;
  overflow: hidden;
  box-sizing: border-box;
}

:deep(.cam-tree .el-tree-node__content:hover) {
  background: #f9fafb;
}

:deep(.cam-tree .el-tree-node__content:hover .tree-node-action) {
  display: inline-flex;
}

:deep(.cam-tree.is-dragging) {
  opacity: 0.85;
}
</style>
